import { Box } from "@mui/material";
import * as React from "react";
import { AppReportTaskTypeTitlePage, IAppReportTaskTypeTitlePage } from "ui/Scripts/source/models/appReportTemplate/appReportTaskTypeTitlePage";
import { AppReportTaskTypeTitlePageData, IAppReportTaskTypeTitlePageData } from "ui/Scripts/source/models/appReportTemplate/appReportTaskTypeTitlePageData";
import { AppReportTaskTypeTitlePageLayout, AppReportTaskTypeTitlePageType } from "ui/Scripts/source/models/enums";
import { ITaskDataRowCol } from "ui/Scripts/source/models/task/taskDataRowCol";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { TaskDynamicFormPageBreak } from "./TaskDynamicFormPageBreak";

export interface ITaskDynamicFormTitlePageLayoutProp {
    titlePage: IAppReportTaskTypeTitlePage;
    titlePageData: IAppReportTaskTypeTitlePageData;
}

const TaskDynamicFormTitlePageLayout1 = (props: ITaskDynamicFormTitlePageLayoutProp) => {
    return (
        <>
            <Box
                className="preWrap"
                style={{
                    marginTop: "2rem",
                    fontSize: "48px",
                    fontWeight: "bold",
                    textAlign: "center",
                }}
            >
                {props.titlePage.name}
            </Box>
            {!!props.titlePage.description &&
                <Box
                    className="preWrap"
                    style={{
                        marginTop: "1rem",
                        textAlign: "center",
                    }}
                >
                    {props.titlePage.description}
                </Box>
            }
            {!!props.titlePageData.timeSpan &&
                <Box
                    style={{
                        marginTop: "1rem",
                        textAlign: "center",
                    }}
                >
                    {props.titlePageData.timeSpan}
                </Box>
            }
            {!!props.titlePage.image &&
                <img
                    style={{
                        marginTop: "1rem",
                        marginLeft: "10%",
                        marginRight: "10%",
                        width: "80%",
                        objectFit: "contain",
                    }}
                    src={props.titlePage.image}
                >
                </img>
            }
            {props.titlePage.type === AppReportTaskTypeTitlePageType.CoverPage &&
                <TaskDynamicFormPageBreak taskTypeCol={null!} />
            }
        </>
    );
};

export interface ITaskDynamicFormTitlePageProp {
    taskTypeCol: ITaskTypeCol;
    taskDataRowCol: ITaskDataRowCol;
}

export const TaskDynamicFormTitlePage = (props: ITaskDynamicFormTitlePageProp) => {
    const titlePage = new AppReportTaskTypeTitlePage(props.taskTypeCol?.objectValue);
    const titlePageData = new AppReportTaskTypeTitlePageData(props.taskDataRowCol?.valueObj);

    return (
        <Box className="titlePage">
            {titlePage.layout === AppReportTaskTypeTitlePageLayout.Layout1 &&
                <TaskDynamicFormTitlePageLayout1
                    titlePage={titlePage}
                    titlePageData={titlePageData}
                />
            }
        </Box>
    );
};